import React from "react";
import { Stack, Box } from "@mui/material";
import { Operation } from "../../../../networkRequest/operationsService";
import { OperationDate } from "../../components";

interface OperationDateInfoProps {
    operation: Operation;
}

const OperationDateInfo: React.FC<OperationDateInfoProps> = ({ operation }) => {
    return (
        <Stack
            sx={{
                alignItems: "flex-start",
                pt: '6px',
                minWidth: '280px'
            }}>
            <OperationDate 
                date={operation.start_date} 
                label="Start"
            />

            <Box sx={{ height: (theme) => theme.spacing(2.75) }} />

            <OperationDate 
                date={operation.end_date} 
                label="End"
            />
        </Stack>
    );
};

export default OperationDateInfo;